const SOFTWALL_BOUNCE_KEY = "BT_AM_SOFTWALL_BOUNCE";

export const hasBounceData = () =>
  sessionStorage.getItem(SOFTWALL_BOUNCE_KEY) === "true";

export const saveBounceData = () =>
  sessionStorage.setItem(SOFTWALL_BOUNCE_KEY, "true");
export const deleteBounceData = () =>
  sessionStorage.removeItem(SOFTWALL_BOUNCE_KEY);
